import { render, staticRenderFns } from "./apichannelreport-add-or-update.vue?vue&type=template&id=66b86822&"
import script from "./apichannelreport-add-or-update.vue?vue&type=script&lang=js&"
export * from "./apichannelreport-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports